import { Form, Select, Typography } from 'antd';

import type { DefaultOptionType } from 'antd/es/select';
import type { FC } from 'react';

const { Text } = Typography;
const { Item } = Form;

interface Props {
  salesFunnels: Array<DefaultOptionType>;
  salesFunnelsStages: Array<DefaultOptionType>;
  onSalesFunnelChange(value: number): void;
  errorRequiredField: string;
  isIntegrationRegistryComponent: boolean;
}

export const SalesFunnelFormItems: FC<Props> = ({
  salesFunnels,
  salesFunnelsStages,
  onSalesFunnelChange,
  errorRequiredField,
  isIntegrationRegistryComponent,
}) => (
  <>
    <Text strong className="mb-8 label-require">
      Воронка продаж
    </Text>
    {isIntegrationRegistryComponent && (
      <Text className="mb-12 gray">
        Выберите воронку продаж, в которую будут попадать лиды с этой
        интеграции.
      </Text>
    )}
    <Item
      className="mb-12"
      name="salesFunnel"
      rules={[{ required: true, message: errorRequiredField }]}
    >
      <Select
        showSearch
        placeholder="Выберите воронку продаж"
        optionFilterProp="label"
        onChange={onSalesFunnelChange}
        options={salesFunnels}
      />
    </Item>
    <Item
      name="salesFunnelStage"
      rules={[{ required: true, message: errorRequiredField }]}
    >
      <Select
        showSearch
        placeholder="Выберите этап воронки"
        optionFilterProp="label"
        options={salesFunnelsStages}
      />
    </Item>
  </>
);
